import { render, staticRenderFns } from "./app-scanInput.vue?vue&type=template&id=21c55f4c"
import script from "./app-scanInput.vue?vue&type=script&lang=js"
export * from "./app-scanInput.vue?vue&type=script&lang=js"
import style0 from "./app-scanInput.vue?vue&type=style&index=0&id=21c55f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports